import Flickity from 'flickity';

/**
 * TODO: Implement
 * Key provided:
 * 
 * IGQVJWVFM1Ty1qNmwtejN5U1ZAXWVVRWm1BclZA5X09RdkROQ3dFRXpqMHEzSFVDdkE1U3FUVkdVQ2N2eDFkaEJkLWU4b183VGUzaU1VVXc0OTNhUTdZAXzhaREZABWkgwRnB0aENtdnMxRXV6NV82MkUyLQZDZD
 */

export default {
  init($element) {

  },
  finalize($element) {

    var images = [];

    var feedCarousel = null;

    $('.sbi_load_btn').trigger('click');

    if ($('#sb_instagram').length > 0) {

      const observer = new MutationObserver(function(mutationsList, observer) {
        images = [];
        
        $element.find('#sb_instagram #sbi_images .sbi_item:not(.sbi_type_video)').each(function() {
          images.push($(this).find('.sbi_photo_wrap .sbi_photo img').prop('src'));
        });

        images.forEach((image, index) => {
          const $carouselItem = $(`
            <div class="carousel-cell">
              <div class="cell-inner">
                <img src="${image}" class="cell-image" />
              </div>
            </div>
          `);

          $carouselItem.appendTo($element.find('.feed-carousel'));
        });

        // Destroy any previous carousel
        if (feedCarousel) {
          feedCarousel.destroy();
        }

        // Now we can init the carousel
        feedCarousel = new Flickity($element.find('.feed-carousel').get()[0], {
          // autoPlay: 1500,
          pauseAutoPlayOnHover: false,
          prevNextButtons: false,
          pageDots: false,
          contain: true,
          freeScroll: true,
          wrapAround: true,
          on: {
            ready: function() {
              setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
              }, 250);
            },
          },
        });
        
        setInterval(() => {
          feedCarousel.applyForce( -0.5 );
          feedCarousel.startAnimation();
          feedCarousel.dragEnd();
        }, 150);

      }).observe($('#sb_instagram').get()[0], {
        attributes: false,
        childList: true,
        subtree: true,
      });
    }


    // setInterval(() => {
    //   $element.find('.flickity-slider').css({ transform: 'translateX(-1%)' });
    //   $element.find('.flickity-viewport').trigger('mouseup');
    // }, 100);

  },
}


// WEBPACK FOOTER //
// ./scripts/partials/home/instagramFeed.js